export const INITIAL_STATE = {
  novoBeneficio: [],
  atualizarBeneficio: [],
  gruposBeneficios: [],
  grupoAtualizacao: [],
  atualizacaoBeneficio: [],
  loading: false
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {   
    case 'GRUPO_ATUALIZACAO_GET_ALL_REQUEST':
      return { ...state, loading: true, grupoAtualizacao: action.payload };
    case 'GRUPO_ATUALIZACAO_GET_ALL_SUCCESS':
      return { ...state, loading: false, grupoAtualizacao: action.payload };
    case 'GRUPO_ATUALIZACAO_GET_ALL_FAILURE':
      return { ...state, loading: false, grupoAtualizacao: action.payload }; 
    case 'GRUPOS_BENEFICIOS_GET_ALL_REQUEST':
      return { ...state, loading: true, gruposBeneficios: action.payload };
    case 'GRUPOS_BENEFICIOS_GET_ALL_SUCCESS':
      return { ...state, loading: false, gruposBeneficios: action.payload };
    case 'GRUPOS_BENEFICIOS_GET_ALL_FAILURE':
      return { ...state, loading: false, gruposBeneficios: action.payload };
    case 'NOVO_BENEFICIO_GET_ALL_REQUEST':
      return { ...state, loading: true, novoBeneficio: action.payload };
    case 'NOVO_BENEFICIO_GET_ALL_SUCCESS':
      return { ...state, loading: false, novoBeneficio: action.payload };
    case 'NOVO_BENEFICIO_GET_ALL_FAILURE':
      return { ...state, loading: false, novoBeneficio: action.payload };
    case 'ATUALIZACAO_BENEFICIO_GET_ALL_REQUEST':
      return { ...state, loading: true, atualizacaoBeneficio: action.payload };
    case 'ATUALIZACAO_BENEFICIO_GET_ALL_SUCCESS':
      return { ...state, loading: false, atualizacaoBeneficio: action.payload };
    case 'ATUALIZACAO_BENEFICIO_GET_ALL_FAILURE':
      return { ...state, loading: false, atualizacaoBeneficio: action.payload };
    default:
      return state;
  }
}